import angular from 'angular';
import './messageTemplatePaymentCard.scss';
import PaymentCardView from './messageTemplatePaymentCardView.html';
import { MessageTemplateFeatures } from '../MessageTemplateFeatures';
import { HTTP_URL_REGEX, MessageTemplateButtonTypes, CallToActionTypes, verifyActionsValueLength, } from '../models/MessageTemplateButtons';
class MessageTemplatePaymentCardController {
    static $inject = ['$element', '$translate', '$scope', '$timeout', 'MessageTemplateUtil'];
    /**
     * Valida se os campos obrigatórios do header estão preenchidos conforme o tipo selecionado.
     * @returns boolean - true se válido, false se inválido
     */
    isHeaderValid() {
        if (this.selectedHeaderType === 'text') {
            return !!(this.$scope.headerValue &&
                this.$scope.headerValue.trim().length > 0);
        }
        if (this.selectedHeaderType === 'image') {
            return !!(this.imagePaymentLink && this.imagePaymentLink.trim().length > 0);
        }
        if (this.selectedHeaderType === 'document') {
            return !!(this.documentLink && this.documentLink.trim().length > 0);
        }
        return true;
    }
    constructor($element, $translate, $scope, $timeout, MessageTemplateUtil) {
        'ngInject';
        this.isConfirmed = false;
        this.showHeader = true;
        this.isButtonValid = true;
        this.showFooterPayment = true;
        this.selectedHeaderType = 'text';
        this.imagePaymentLink = '';
        this.documentLink = '';
        this.defaultImageFallback = '';
        this.headerValue = '';
        this.headerType = 'text';
        this.useFormattedHtml = false;
        this.showFooter = true;
        this.showFooterModal = true;
        this.isModal = false;
        this.documentName = '';
        this.imageLink = '';
        this.toggleFooterPayment = event => {
            const switchValue = event.detail.checked;
            if (this.showFooterPayment === switchValue) {
                return;
            }
            this.showFooterPayment = switchValue;
        };
        this.handleHeaderTypeChange = event => {
            this.selectedHeaderType = event.detail.value;
            this.$scope.headerValue = '';
            this.headerValue = '';
            this.clearHeaderVariables();
        };
        this.handleImageLinkChange = event => {
            this.imagePaymentLink = event.detail.value || '';
        };
        this.handleDocumentLinkChange = event => {
            this.documentLink = event.detail.value || '';
        };
        this.$element = $element;
        this.$translate = $translate;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.MessageTemplateUtil = MessageTemplateUtil;
        // Não sobrescreva o objeto $scope, apenas defina as propriedades
        this.$scope.editionEnabled = false;
        this.$scope.previewMode = false;
        this.$scope.readMore = false;
        this.$scope.bold = false;
        this.$scope.italic = false;
        this.$scope.strikethrough = false;
        this.$scope.inputValue = '';
        this.$scope.footerValue = '';
        this.$scope.headerValue = '';
        this.$scope.value = '';
        this.$scope.selectedText = {
            finalText: '',
            initialText: '',
            textSelected: '',
        };
        this.$scope.selectedHeaderText = {
            finalText: '',
            initialText: '',
            textSelected: '',
        };
    }
    async $onInit() {
        if (this.showHeader === undefined) {
            this.showHeader = true;
        }
        await this.checkFeatures();
        this.initializeDefaults();
        this.initializeBindings();
        if (this.type === 'payment') {
            this.setupPaymentCard();
        }
        this.setupPreviewMode();
        this.setupEditMode();
        this.defaultImageFallback =
            'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZmlsbD0iIzQ1NDU0NSIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNS40MyAyaDEzLjE0QTMuNDIgMy40MiAwIDAgMSAyMiA1LjQzdjEzLjE0QTMuNDIgMy40MiAwIDAgMSAxOC41NyAyMkg1LjQzQTMuNDIgMy40MiAwIDAgMSAyIDE4LjU3VjUuNDNBMy40MiAzLjQyIDAgMCAxIDUuNDMgMm0xMy4xNCAxLjVINS40M0ExLjkyIDEuOTIgMCAwIDAgMy41IDUuNDN2MTAuMjNMNS42NSAxNGExLjk0IDEuOTQgMCAwIDEgMi43LjA1bDEuNDcgMS4xOCA0LjQ5LTQuNDFhMiAyIDAgMCAxIDIuNzYgMGwzLjQzIDMuNTF2LTguOWExLjkyIDEuOTIgMCAwIDAtMS45My0xLjkzbS0xMy4xNCAxN2gxMy4xNGExLjkyIDEuOTIgMCAwIDAgMS45LTEuOTV2LTIuMWwtNC40NS00LjU3YS40Ny40NyAwIDAgMC0uNjUgMEwxMSAxNi4xOCAxMy4yNiAxOGEuNzUuNzUgMCAwIDEtLjQ0IDEuMjkuNzIuNzIgMCAwIDEtLjQ3LS4xN2wtNS00YS41LjUgMCAwIDAtLjcxIDBMMy41IDE3LjU3djFhMS45MiAxLjkyIDAgMCAwIDEuOTMgMS45M20yLjc3LTkuNTRhLjA3LjA3IDAgMCAwLS4wNC0uMDIgMy4yIDMuMiAwIDAgMS0yLjEtLjY1IDIuOTMgMi45MyAwIDAgMS0uNjktMiAyLjI5IDIuMjkgMCAwIDEgLjktMi4xMkEzLjUgMy41IDAgMCAxIDggNS44YTUuOCA1LjggMCAwIDEgMS4xNy4xMSAxLjg3IDEuODcgMCAwIDEgMS41NCAxLjVBMy41IDMuNSAwIDAgMSAxMC4zIDEwYTcgNyAwIDAgMS0uODguOTVjLS4zNC4zLS42Ny41OS0xIC44N2gtLjA3YS4xMy4xMyAwIDAgMS0uMTMtLjEyVjExYS4wNy4wNyAwIDAgMC0uMDItLjA0IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=';
    }
    initializeDefaults() {
        this.selectedHeaderType = 'text';
        this.showFooterPayment = true;
    }
    initializeBindings() {
        if (this.description) {
            this.$scope.inputValue = this.description.replace(/\\n/g, '\n');
            this.description = this.description.replace(/\\n/g, '\n');
        }
        if (this.footerValue) {
            this.$scope.footerValue = this.footerValue;
        }
        if (this.headerValue) {
            this.$scope.headerValue = this.headerValue;
        }
        else if (this.value) {
            this.$scope.headerValue = this.value;
        }
        if (this.headerType) {
            this.selectedHeaderType = this.headerType;
        }
        if (this.imageLink) {
            this.imagePaymentLink = this.imageLink;
        }
    }
    setupPreviewMode() {
        if (this.onlyPreview) {
            this.$scope.editionEnabled = false;
            this.$scope.previewMode = true;
            this.setupFooterVisibility();
            this.$scope.$watch(() => this.footerValue, newValue => {
                if (newValue !== undefined && this.$scope) {
                    this.$scope.footerValue = newValue;
                }
            });
        }
        else {
            this.setupFooterVisibility();
        }
    }
    setupFooterVisibility() {
        const footerValue = this.showFooterModal !== undefined
            ? this.showFooterModal
            : this.showFooter;
        if (footerValue === true || footerValue === 'true') {
            this.showFooterPayment = true;
        }
        else if (footerValue === false || footerValue === 'false') {
            this.showFooterPayment = false;
        }
        else {
            this.showFooterPayment = true;
        }
    }
    setupEditMode() {
        if (!this.onlyPreview) {
            this.setupButtons();
            this.setupTextareaListeners();
        }
    }
    setupButtons() {
        if (this.isMessageTemplateButtonsEnabled) {
            this.copySandboxButtons();
        }
        else {
            this.resetButtonsToDefault();
        }
    }
    copySandboxButtons() {
        this.sandboxOptions = angular.copy(this.options);
        this.sandboxButtonType = this.buttonType;
    }
    resetButtonsToDefault() {
        this.options = [];
        this.buttonType = MessageTemplateButtonTypes.DEFAULT;
        this.sandboxOptions = [];
        this.sandboxButtonType = MessageTemplateButtonTypes.DEFAULT;
    }
    setupTextareaListeners() {
        this.addListenerOnTextarea();
        this.addListenerOnHeaderTextarea();
    }
    $onChanges(changes) {
        // React to changes in bindings
        if (changes.imageLink && changes.imageLink.currentValue) {
            this.imagePaymentLink = changes.imageLink.currentValue;
        }
        if (changes.headerType && changes.headerType.currentValue) {
            this.selectedHeaderType = changes.headerType.currentValue;
        }
        if (changes.showFooter !== undefined) {
            const value = changes.showFooter.currentValue;
            this.showFooterPayment = value === true || value === 'true';
        }
        if (changes.showFooterModal !== undefined) {
            const value = changes.showFooterModal.currentValue;
            this.showFooterPayment = value === true || value === 'true';
        }
        if (changes.footer !== undefined) {
            const newFooterValue = changes.footer.currentValue;
            this.footerValue = newFooterValue || '';
            if (this.$scope) {
                this.$scope.footerValue = newFooterValue || '';
                this.$scope.$applyAsync();
            }
        }
        if (changes.footerValue !== undefined) {
            const newFooterValue = changes.footerValue.currentValue;
            this.footerValue = newFooterValue || '';
            if (this.$scope) {
                this.$scope.footerValue = newFooterValue || '';
                this.$scope.$applyAsync();
            }
        }
    }
    setupPaymentCard() {
        this.documentLink = '';
        this.imagePaymentLink = '';
        this.initializeButtonOptions();
    }
    initializeButtonOptions() {
        // Method simplified - functionality moved to resetButtonsToDefault and copySandboxButtons
    }
    async checkFeatures() {
        this.isMessageTemplateButtonsEnabled = await MessageTemplateFeatures.isMessageTemplateButtonsEnabled();
    }
    $onDestroy() {
        setTimeout(() => {
            const textareaElement = this.getTextareaElement();
            const headerTextareaElement = this.getHeaderTextareaElement();
            textareaElement?.removeEventListener('select', this.onSelectText.bind(this));
            textareaElement?.removeEventListener('mouseup', () => setTimeout(this.clearSelectedText.bind(this), 50));
            textareaElement?.removeEventListener('keydown', () => setTimeout(this.clearSelectedText.bind(this), 50));
            headerTextareaElement?.removeEventListener('select', this.onSelectHeaderText.bind(this));
            headerTextareaElement?.removeEventListener('mouseup', () => setTimeout(this.clearSelectedHeaderText.bind(this), 50));
            headerTextareaElement?.removeEventListener('keydown', () => setTimeout(this.clearSelectedHeaderText.bind(this), 50));
        }, 1000);
    }
    getTextareaElement() {
        const element = this.$element[0];
        return element.querySelector('textarea[ng-model="$ctrl.$scope.inputValue"]');
    }
    getPreviewElement() {
        const element = this.$element[0];
        return element.querySelector('.mt-card__preview .mt-card__preview__text');
    }
    getFooterElement() {
        const element = this.$element[0];
        return element.querySelector('.mt-card__preview__footer');
    }
    addListenerOnTextarea() {
        setTimeout(() => {
            const textareaElement = this.getTextareaElement();
            if (textareaElement) {
                textareaElement.onselect = this.onSelectText.bind(this);
                textareaElement.onmouseup = () => setTimeout(this.clearSelectedText.bind(this), 50);
                textareaElement.onkeydown = () => setTimeout(this.clearSelectedText.bind(this), 50);
            }
        }, 100);
    }
    onSelectText(event) {
        const target = event.target;
        const selectionStart = target['selectionStart'];
        const selectionEnd = target['selectionEnd'];
        const value = target['value'];
        const textSelected = document.getSelection().toString();
        const initialText = value.substring(0, selectionStart);
        const finalText = value.substring(selectionEnd, value.length);
        this.$scope.selectedText = { textSelected, initialText, finalText };
    }
    clearSelectedText() {
        const textSelected = document.getSelection().toString();
        if (!textSelected.length &&
            this.$scope.selectedText.textSelected.length) {
            this.clearSelectedTextScope();
        }
    }
    clearSelectedTextScope() {
        this.$scope.selectedText = {
            finalText: '',
            initialText: '',
            textSelected: '',
        };
    }
    clearSelectedHeaderText() {
        const textSelected = document.getSelection().toString();
        if (!textSelected.length &&
            this.$scope.selectedHeaderText.textSelected.length) {
            this.clearSelectedHeaderTextScope();
        }
    }
    clearSelectedHeaderTextScope() {
        this.$scope.selectedHeaderText = {
            finalText: '',
            initialText: '',
            textSelected: '',
        };
    }
    enableEdition() {
        if (this.allowEdit === false)
            return;
        if (!this.onlyPreview) {
            this.$scope.editionEnabled = true;
            this.$scope.previewMode = false;
        }
        this.formatPreviewView(this.description, this.footerValue);
    }
    closeEditionMode() {
        this.$scope.editionEnabled = false;
        this.$scope.previewMode = false;
        this.$scope.selectedText = {
            finalText: '',
            initialText: '',
            textSelected: '',
        };
        this.$scope.selectedHeaderText = {
            finalText: '',
            initialText: '',
            textSelected: '',
        };
        if (!this.isTranslation()) {
            this.description = this.$scope.inputValue;
            this.footerValue = this.$scope.footerValue;
            if (this.selectedHeaderType === 'text') {
                this.headerValue = this.$scope.headerValue;
            }
        }
        if (!this.isMessageTemplateButtonsEnabled) {
            this.resetButtonsToDefault();
        }
    }
    clearHeaderVariables() {
        if (this.$scope.headerValue) {
            this.$scope.headerValue = '';
        }
        if (this.headerValue) {
            this.headerValue = '';
        }
    }
    formatPreviewView(message, footerMessage) {
        const previewElement = this.getPreviewElement();
        const footerElement = this.getFooterElement();
        if (previewElement && message) {
            const formattedMessage = this.MessageTemplateUtil.formatMessageToPreviewView(message);
            previewElement.innerHTML = formattedMessage;
        }
        if (footerElement && footerMessage) {
            const formattedFooter = this.MessageTemplateUtil.formatMessageToPreviewView(footerMessage);
            footerElement.innerHTML = formattedFooter;
        }
    }
    addVariable() {
        const textareaElement = this.getTextareaElement();
        const variables = textareaElement.value.match(/{{\d{1,10}}}/gm);
        const lastVariable = variables
            ? variables
                .map(variable => parseInt(variable.replace(/[{}]/gm, '')))
                .sort((a, b) => a - b)[variables.length - 1]
            : 0;
        textareaElement.value += `{{${lastVariable + 1}}}`;
        textareaElement.focus();
        this.$scope.inputValue = textareaElement.value;
    }
    addSymbolOnText(symbol) {
        const textareaElement = this.getTextareaElement();
        if (this.$scope.selectedText.textSelected.length) {
            const { finalText, initialText, textSelected, } = this.$scope.selectedText;
            textareaElement.value =
                initialText + symbol + textSelected + symbol + finalText;
            this.clearSelectedTextScope();
            textareaElement.focus();
        }
        else {
            textareaElement.value += symbol + symbol;
            textareaElement.focus();
            const setInPosition = textareaElement.value.length - 1;
            textareaElement.setSelectionRange(setInPosition, setInPosition);
        }
        this.$scope.inputValue = textareaElement.value;
    }
    applyBoldOnText() {
        this.addSymbolOnText('*');
    }
    applyItalicOnText() {
        this.addSymbolOnText('_');
    }
    applyStrikethroughOnText() {
        this.addSymbolOnText('~');
    }
    getHeaderTextareaElement() {
        const element = this.$element[0];
        return element.querySelector('textarea[ng-model="$ctrl.$scope.headerValue"]');
    }
    addListenerOnHeaderTextarea() {
        setTimeout(() => {
            const textareaElement = this.getHeaderTextareaElement();
            if (textareaElement) {
                textareaElement.onselect = this.onSelectHeaderText.bind(this);
                textareaElement.onmouseup = () => setTimeout(this.clearSelectedHeaderText.bind(this), 50);
                textareaElement.onkeydown = () => setTimeout(this.clearSelectedHeaderText.bind(this), 50);
            }
        }, 100);
    }
    onSelectHeaderText(event) {
        const target = event.target;
        const selectionStart = target['selectionStart'];
        const selectionEnd = target['selectionEnd'];
        const value = target['value'];
        const textSelected = document.getSelection().toString();
        const initialText = value.substring(0, selectionStart);
        const finalText = value.substring(selectionEnd, value.length);
        this.$scope.selectedHeaderText = {
            textSelected,
            initialText,
            finalText,
        };
    }
    checkSelectionHeader() {
        setTimeout(() => {
            const textSelected = document.getSelection().toString();
            if (textSelected.length) {
                this.$scope.selectedHeaderText = {
                    textSelected,
                    initialText: '',
                    finalText: '',
                };
            }
        }, 50);
    }
    addSymbolOnHeaderText(symbol) {
        const textareaElement = this.getHeaderTextareaElement();
        if (this.$scope.selectedHeaderText.textSelected.length) {
            const { finalText, initialText, textSelected, } = this.$scope.selectedHeaderText;
            textareaElement.value =
                initialText + symbol + textSelected + symbol + finalText;
            this.clearSelectedHeaderTextScope();
            textareaElement.focus();
        }
        else {
            textareaElement.value += symbol + symbol;
            textareaElement.focus();
            const setInPosition = textareaElement.value.length - 1;
            textareaElement.setSelectionRange(setInPosition, setInPosition);
        }
        this.$scope.headerValue = textareaElement.value;
    }
    applyBoldOnHeaderText() {
        this.addSymbolOnHeaderText('*');
    }
    applyItalicOnHeaderText() {
        this.addSymbolOnHeaderText('_');
    }
    applyStrikethroughOnHeaderText() {
        this.addSymbolOnHeaderText('~');
    }
    /**
     * Retorna true se já existe uma variável (ex: {{alguma_coisa}}) no headerValue
     */
    hasHeaderVariable() {
        // Considera qualquer variável entre {{ e }}
        return /{{.*?}}/.test(this.$scope.headerValue || '');
    }
    /**
     * Adiciona uma variável ao header, permitindo apenas uma ocorrência.
     * Manipula apenas o modelo, não o DOM.
     */
    addVariableToHeader() {
        if (this.hasHeaderVariable())
            return;
        this.$scope.headerValue = (this.$scope.headerValue || '') + '{{1}}';
    }
    getHeaderVariables() {
        if (this.selectedHeaderType !== 'text' || !this.$scope.headerValue) {
            return null;
        }
        const variables = this.$scope.headerValue.match(/{{\d{1,10}}}/gm);
        return variables
            ? variables.sort((a, b) => {
                const numA = parseInt(a.replace(/[{}]/gm, ''));
                const numB = parseInt(b.replace(/[{}]/gm, ''));
                return numA - numB;
            })
            : null;
    }
    getBodyVariables() {
        if (!this.$scope.inputValue) {
            return null;
        }
        const variables = this.$scope.inputValue.match(/{{\d{1,10}}}/gm);
        return variables
            ? variables.sort((a, b) => {
                const numA = parseInt(a.replace(/[{}]/gm, ''));
                const numB = parseInt(b.replace(/[{}]/gm, ''));
                return numA - numB;
            })
            : null;
    }
    hasVariables() {
        const headerVars = this.getHeaderVariables();
        const bodyVars = this.getBodyVariables();
        return ((headerVars && headerVars.length > 0) ||
            (bodyVars && bodyVars.length > 0));
    }
    hasButtons() {
        return (this.buttonType === MessageTemplateButtonTypes.QUICK_REPLY ||
            this.buttonType === MessageTemplateButtonTypes.CALL_TO_ACTION);
    }
    verifyIfButtonsIsInvalid() {
        if (this.sandboxButtonType === MessageTemplateButtonTypes.DEFAULT) {
            return false;
        }
        if (!this.sandboxOptions || !Array.isArray(this.sandboxOptions)) {
            return false;
        }
        const valueArr = this.sandboxOptions.map(item => item.inputText) || [];
        const isDuplicate = valueArr.some((item, idx) => {
            return valueArr.indexOf(item) !== idx;
        });
        const hasInvalidButtonName = valueArr.find((item) => item?.length === 0 || item?.length > 20);
        if (this.sandboxButtonType === MessageTemplateButtonTypes.CALL_TO_ACTION) {
            const callToActionisValid = this.sandboxOptions.find(item => (item.url === '' && item.phone_number === '') ||
                verifyActionsValueLength(item.url, true) ||
                verifyActionsValueLength(item.phone_number, false) ||
                (item.type === CallToActionTypes.URL &&
                    !new RegExp(HTTP_URL_REGEX).test(item.url)));
            if (callToActionisValid) {
                return true;
            }
        }
        return isDuplicate || hasInvalidButtonName !== undefined;
    }
    getFooterText() {
        return (this.footerValue ||
            this.$translate('messageTemplatePaymentCard.exampleFooterText'));
    }
    save() {
        if (this.verifyIfButtonsIsInvalid()) {
            return;
        }
        this.prepareDataForSave();
        const buttonsArray = this.buildButtonsArray();
        const content = this.buildContentObject();
        this.isConfirmed = true;
        this.onConfirm({
            $event: {
                content,
                buttonsArray,
            },
        });
        this.closeEditionMode();
    }
    prepareDataForSave() {
        this.$scope.inputValue = (this.$scope.inputValue || '').trim();
        this.$scope.footerValue = (this.$scope.footerValue || '').trim();
        this.$scope.headerValue = (this.$scope.headerValue || '').trim();
        this.options = this.sandboxOptions || [];
        this.buttonType = this.sandboxButtonType;
    }
    buildButtonsArray() {
        const buttonsArray = [];
        if (!this.isMessageTemplateButtonsEnabled) {
            return buttonsArray;
        }
        this.options = angular.copy(this.sandboxOptions || []);
        this.buttonType = this.sandboxButtonType;
        if (this.buttonType !== MessageTemplateButtonTypes.DEFAULT &&
            this.options &&
            Array.isArray(this.options)) {
            this.options.map(button => {
                buttonsArray.push(this.createButtonObject(button));
            });
        }
        return buttonsArray;
    }
    createButtonObject(button) {
        if (button.type === CallToActionTypes.PHONE_NUMBER) {
            return {
                type: button.type.toUpperCase(),
                text: button.text,
                phone_number: button.phone_number,
            };
        }
        else if (button.type === CallToActionTypes.URL) {
            return {
                type: button.type.toUpperCase(),
                text: button.text,
                url: button.url,
            };
        }
        else {
            return {
                type: this.buttonType.toUpperCase(),
                text: button.text,
            };
        }
    }
    buildContentObject() {
        return {
            description: this.$scope.inputValue,
            footer: this.$scope.footerValue,
            header: this.$scope.headerValue,
            headerType: this.selectedHeaderType,
            imageLink: this.imagePaymentLink,
            documentLink: this.documentLink,
            showFooter: this.showFooterPayment,
            headerVariables: this.getHeaderVariables(),
            bodyVariables: this.getBodyVariables(),
        };
    }
}
MessageTemplatePaymentCardController.$inject = ['$element', '$translate', '$scope', '$timeout', 'MessageTemplateUtil'];
MessageTemplatePaymentCardController.$inject = [
    '$element',
    '$translate',
    '$scope',
    '$timeout',
    'MessageTemplateUtil',
];
export const MessageTemplatePaymentCardComponent = {
    template: PaymentCardView,
    controller: MessageTemplatePaymentCardController,
    controllerAs: '$ctrl',
    bindings: {
        onConfirm: '&',
        value: '@?',
        description: '@?',
        footer: '@?',
        type: '@',
        onlyPreview: '<?',
        buttonType: '=?',
        options: '=?',
        thereTranslations: '&?',
        isTranslation: '&?',
        headerType: '@?',
        headerValue: '@?',
        footerValue: '@?',
        useFormattedHtml: '<?',
        imageLink: '@?',
        documentLink: '@?',
        showFooter: '<?',
        showFooterModal: '<?',
        isModal: '<?',
        allowEdit: '<?',
        showHeader: '<?',
    },
};
